"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CheckBox = _interopRequireDefault(require("./CheckBox.styled"));
var _excluded = ["label", "id", "name", "disabled", "automationId", "className", "checkBoxStyle", "children", "errorMessage", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CheckBox = /*#__PURE__*/_react["default"].forwardRef(function CheckBox(_ref, ref) {
  var label = _ref.label,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    automationId = _ref.automationId,
    className = _ref.className,
    _ref$checkBoxStyle = _ref.checkBoxStyle,
    checkBoxStyle = _ref$checkBoxStyle === void 0 ? '' : _ref$checkBoxStyle,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    errorMessage = _ref.errorMessage,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var propertyClasses = [];
  (0, _react.useEffect)(function () {
    if (!automationId) {
      console.warn("Automation id was not provided.");
    }
  }, [automationId]);
  if (checkBoxStyle.toLowerCase().trim() === 'compact') {
    propertyClasses.push('compact');
  }
  if (errorMessage) {
    propertyClasses.push('error');
  }
  if (disabled) {
    propertyClasses.push('disabled');
  }
  var checkBoxRef = (0, _react.useRef)();
  var handleKeyDown = function handleKeyDown(e) {
    // spacebar
    if (e.target === checkBoxRef.current && e.keyCode === 32 && !disabled) {
      e.target.children[0].checked = !e.target.children[0].checked;
      // Set e.target here so it will be the checkbox itself returned for the onChange
      e.target = e.target.children[0];
      if (props.onChange) {
        props.onChange(e);
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], {
    className: className + " " + propertyClasses.join(" "),
    role: "checkbox",
    tabIndex: "0",
    ref: checkBoxRef,
    onKeyDown: handleKeyDown,
    errorMessage: errorMessage
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    id: id,
    name: name || id,
    "data-test-id": automationId,
    type: "checkbox",
    onChange: onChange,
    disabled: disabled,
    ref: ref
  }, props)), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, label || children), errorMessage ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "error-message"
  }, errorMessage) : null);
});
var _default = exports["default"] = CheckBox;
CheckBox.defaultProps = {
  label: '',
  id: '',
  disabled: false,
  automationId: '',
  className: '',
  checkBoxStyle: 'default',
  errorMessage: ''
};
CheckBox.propTypes = {
  label: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  automationId: _propTypes["default"].string,
  className: _propTypes["default"].string,
  checkBoxStyle: _propTypes["default"].oneOf(['', 'default', 'compact']),
  errorMessage: _propTypes["default"].string,
  name: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  onChange: _propTypes["default"].func
};